import React from "react";

export default function EmptyState({ icon: Icon, title, subtitle, action, testId }) {
  return (
    <div
      className="border-2 border-dashed border-erf-borderCream bg-erf-creamSecondary rounded-md p-10 text-center flex flex-col items-center justify-center gap-3"
      data-testid={testId || "empty-state"}
    >
      {Icon && <Icon className="w-10 h-10 text-erf-gold opacity-80" strokeWidth={1.5} />}
      <div className="font-display font-semibold text-base text-erf-dark">{title}</div>
      {subtitle && <div className="text-xs text-erf-dark/60 max-w-md font-nav">{subtitle}</div>}
      {action}
    </div>
  );
}
